import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { sponsorsAPI } from '@/services/sponsorsApi';
import { queryKeys } from './queryKeys';

export function useSponsors(raceId?: any) {
  return useQuery({
    queryKey: queryKeys.sponsors.all(raceId),
    queryFn: () => sponsorsAPI.getSponsors(raceId),
    enabled: !!raceId,
  });
}

export function useCreateSponsor(raceId?: any) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => sponsorsAPI.createSponsor(raceId, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.sponsors.all(raceId) }),
  });
}

export function useUpdateSponsor(raceId?: any) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: any) => sponsorsAPI.updateSponsor(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.sponsors.all(raceId) }),
  });
}

export function useDeleteSponsor(raceId?: any) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => sponsorsAPI.deleteSponsor(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.sponsors.all(raceId) }),
  });
}

export function useUploadSponsorImage() {
  return useMutation({
    mutationFn: (file: any) => sponsorsAPI.uploadImage(file),
  });
}
